import * as React from "react";


interface ILearningContent {
}
class LearningContent extends React.Component<ILearningContent, any> {
    constructor(props: ILearningContent) {
        super(props);
    }

    render() {
        return (
            <div className="LearningContent">
                <h1>LearningContent</h1>
                <div>122</div>
            </div>
        )
    }
}

export default LearningContent;


// WEBPACK FOOTER //
// ./src/components/learningpage/LearningContent.tsx